


















































































































































































































/* eslint-disable */
import { Component, Vue, Watch } from 'vue-property-decorator'
import draggable from 'vuedraggable'
import { Factories } from '@finx/web-repository'
import ApiFake from '@finx/web-repository/src/apis/Fake/Fake'
import ApiLegacy from '@finx/web-repository/src/apis/Legacy/Legacy'
import FuncaoCirurgiao from '@finx/web-repository/src/constants/FuncaoCirurgiao'
import { Config, Procedimento } from '@finx/web-repository/src/types/Calculator'
import { Auth } from '@finx/web-repository/src/services/Oidc'
import CalculadoraVuex from '@/store/CalculadoraVuex'
import AssinaturaStore from '@/store/Assinaturas'
import Animations from '@/factories/Animations'
import DOM from '@/factories/DOM'

Component.registerHooks([
  'beforeRouteLeave',
])

@Component({
  components: {
    draggable,
  }
})

export default class ViewCalculadora extends Vue {
  calculadora: Config = {
    acomodacao: 2,
    codigoTabelaReferencia: '',
    dataReferenciaPorte: '',
    fatorAcomodacao: 100,
    fatorAux1: 0.3,
    fatorAux2: 0.2,
    fatorAux3: 0.2,
    fatorAux4: 0.2,
    fatorCirurgiao: 1,
    fatorCustoOperacionalMedico: 100,
    fatorHonorarioMedico: 100,
    fatorInstrumentador: 0.1,
    fatorUrgencia: 100,
    fatorViaSeparada: 0.7,
    fatorViaUnica: 0.5,
    idPorte: 0,
    idTabelaReferencia: 0,
    percentualCustoOperacional: 100,
    procedimentos: [],
    urgente: false,
    valorDoContrato: false,
  }

  configTabelaIsDone: Boolean = false
  dialogAddProcedimentos: Boolean = false
  dialogSelectTabela: Boolean = false
  dialogShowValores: Boolean = false
  clearValorBaseProcedimento: Boolean = false
  activeStep : Number = 2

  loading: any = {
    status: false,
    text: 'Calculando...',
  }

  loadings: any = {
    getProcedimentos: false,
  }

  loadingProcedimentosList: Boolean = true
  modalProcedimentosListIsOpen: Boolean = false
  porteId: Number = 0
  portes: Array<any> = []


  snackbar: any = {
    disabled: false,
    message: '',
    show: false,
    timeout: 3000,
  }

  tabelaId: Number = 0
  tabelasCBHPM: Array<any> = []

  valorConsolidado: Object = {
    consolidado: {
      valorAux1: 0.00,
      valorAux2: 0.00,
      valorAux3: 0.00,
      valorAux4: 0.00,
      valorCirurgiao: 0.00,
      valorInstrumentador: 0.00,
    },
    total: 0.00
  }

  usuario = {} as Object

  set getShow(value) {
    CalculadoraVuex.dispatch('SET_SHOW_CACULADORA_DIALOG_SELECT_TABELA', value)
  }

  get getShow() {
    return CalculadoraVuex.getters.SHOW_CACULADORA_DIALOG_SELECT_TABELA
  }

  set getShowDialogShowValores(value) {
    CalculadoraVuex.dispatch('SET_SHOW_CACULADORA_DIALOG_SHOW_VALORES', value)
  }

  get getShowDialogShowValores() {
    return CalculadoraVuex.getters.SHOW_CACULADORA_DIALOG_SHOW_VALORES
  }

  get ativarTabelaCBHPM() {
    return CalculadoraVuex.getters.ATIVAR_VALORES_TABELA_CBHPM
  }

  get assinaturaPlanoOperadora() {
    return AssinaturaStore.getters.ASSINATURA_PLANO_CALCULADORA
  }

  ativarTabelaCBHPMStatus(value) {
    CalculadoraVuex.dispatch('SET_ATIVAR_VALORES_TABELA_CBHPM', value)
  }

  async mounted() {
    DOM.toggleBodyOverflow()

    await this.getTabelasPorte()
    await this.setTabelaPorteId()
    //await this.getProcedimentos(null)
    await this.getUser()

    this.ga('calculadora', 'acionar')
  }

  beforeRouteLeave(to, from, next) {
    DOM.toggleBodyOverflow()
    next()
  }

  async clearValorBase() {
    this.calculadora.procedimentos.map(p => {
      p.valorBaseProcedimento = 0
    })

    this.calculateProcedimentos()
  }

  async calculateProcedimentos() {

    if (this.calculadora.procedimentos.length > 0 &&
        (!this.ativarTabelaCBHPM || (this.ativarTabelaCBHPM ))) {
      let calculadora = {
        ...this.calculadora,
        // @ts-ignore
        fatorAcomodacao: this.calculadora.fatorAcomodacao / 100,
        // @ts-ignore
        fatorCustoOperacionalMedico: this.calculadora.fatorCustoOperacionalMedico / 100,
        // @ts-ignore
        fatorHonorarioMedico: this.calculadora.fatorHonorarioMedico / 100,
        // @ts-ignore
        fatorUrgencia: this.calculadora.fatorUrgencia / 100,
        // @ts-ignore
        percentualCustoOperacional: this.calculadora.percentualCustoOperacional / 100,
        valorDoContrato: this.ativarTabelaCBHPM,
        procedimentos: this.removeProcedimentosUselessKeys(this.calculadora.procedimentos)
      }

      calculadora = this.removeCalculadoraUselessKeys(calculadora)
      calculadora.procedimentos[0].viaAcesso = 1

      const request = await ApiLegacy.CalculoProcedimentos.calculateProcedimentos(calculadora)
      const success = Factories.Apis.success(request)

      if (success) {
        this.valorConsolidado = request.data
        this.calculadora.procedimentos = request.data.procedimentos

        this.getMaiorPorte()
      }
    } else {
      this.resetValorConsolidado()
    }
  }

  async calculateProcedimentosJob2() {
    await this.calculateProcedimentos()
    await this.getMaiorPorte()
  }

  async calculateProcedimentosJob1() {
    await this.calculateProcedimentos()
    await this.getMaiorPorte()
  }

  async calculateProcedimentosJob() {
    await this.calculateProcedimentos()
    await this.getMaiorPorte()
  }

  changeStep(step) {
    this.activeStep = step

    if (step == 2) this.setTabelaPorteId()
  }

  deleteProcedimento(indexProcedimento) {
    const procedimentos = this.calculadora.procedimentos.filter((procedimento, index) => {
      if (index !== indexProcedimento) return procedimento
    })

    this.calculadora.procedimentos = procedimentos
  }

  getMaiorPorte() {
    if (this.calculadora.procedimentos.length > 0) {
      let procedimentosHabilitados: any = []

      this.calculadora.procedimentos.map((procedimento: any) => {
        if (procedimento.habilitado) {
          procedimentosHabilitados.push(procedimento)
        }
      })

      if (procedimentosHabilitados.length > 0) {

        if (this.ativarTabelaCBHPM) {
            const maiorPorte = procedimentosHabilitados.reduce((prev: any, current: any) => {
            if (current.valorBaseProcedimento > prev.valorBaseProcedimento) {
              return current
            } else if (current.valorBaseProcedimento == prev.valorBaseProcedimento) {
              return prev
            } else {
              return prev
            }
          })
            this.setMaiorPorte(maiorPorte)
        } else {
          const maiorPorte = procedimentosHabilitados.reduce((prev: any, current: any) => {
          if (current.valorPorte > prev.valorPorte) {
            return current
          } else if (current.valorPorte == prev.valorPorte) {
            return prev
          } else {
            return prev
          }
        })
          this.setMaiorPorte(maiorPorte)
        }
      }
    }
  }



  async getTabelasPorte() {
    const request = await ApiLegacy.Tabelas.getTabelas()
    const success = Factories.Apis.success(request)

    if (success) {
      this.tabelasCBHPM = request.data.tabelasReferencia
      this.portes = request.data.portes

      this.setInitialTabela()
      this.setInitialPorte()
    }
  }

  async getUser() {
    this.usuario = this.$user
  }

  modalProcedimentosListSelected(procedimento) {
    const viaAcesso = 1
    this.snackbar.show = false

    const procedimentoInitial: any = {
      codigoTUSS: procedimento.tuss,
      custoOperacional: null,
      descricao: procedimento.tx,
      isMaiorPorte: false,
      habilitado: true,
      porte: '',
      quantidade: 1,
      quantidadeAuxiliaresPermitido: 0,
      valorCirurgiao: 0.00,
      valorPorte: 0.00,
      viaAcesso: viaAcesso,
      tipoProcedimento: procedimento.tipoProcedimento
    }

    if(CalculadoraVuex.getters.ATIVAR_VALORES_TABELA_CBHPM) {
      procedimentoInitial.valorBaseProcedimento = 0
    } else {
      procedimentoInitial.valorBaseProcedimento = null
    }

    this.calculadora.procedimentos.push(procedimentoInitial)

    this.calculateProcedimentosJob()

    this.modalProcedimentosListIsOpen = false

    if (this.activeStep == 1) this.activeStep = 2

    this.scrollToButton()
  }

  scrollToButton() {
    Animations.smothScroll('#calculadora-content-scroll')
  }

  onListProcedimentosMove(item) {
    if (item.newIndex == 0 || item.oldIndex == 0) {
      this.calculadora.procedimentos[item.newIndex].quantidade = 1
      this.calculateProcedimentos()
    }
  }

  removeCalculadoraUselessKeys(calculadora) {
    delete calculadora.codigoTabelaReferencia
    delete calculadora.dataReferenciaPorte
    delete calculadora.percentualCustoOperacional

    return calculadora
  }

  removeProcedimentosUselessKeys(procedimentosList) {
    let procedimentos: any = []
    procedimentosList.map((procedimento: any, index) => {
      procedimentos.push({
        codigoTUSS: procedimento.codigoTUSS,
        quantidade: procedimento.quantidade,
        viaAcesso: procedimento.viaAcesso,
        valorBaseProcedimento: procedimento.valorBaseProcedimento ? procedimento.valorBaseProcedimento : 0
      })
    })

    return procedimentos
  }

  resetValorConsolidado() {
    const valorConsolidado = {
      consolidado: {
        valorAux1: 0.00,
        valorAux2: 0.00,
        valorAux3: 0.00,
        valorAux4: 0.00,
        valorCirurgiao: 0.00,
        valorInstrumentador: 0.00,
      },
      total: 0.00,
    }

    this.valorConsolidado = valorConsolidado
  }

  async saveDialogSelectTabela(tabelaWasUpdated, tabelaPorteWasUpdated) {
    this.setTabelaPorteId()

    this.dialogSelectTabela = false
    this.configTabelaIsDone = true

    if (tabelaPorteWasUpdated) {
      //this.getProcedimentos(null)
      this.calculateProcedimentos()
    } else {
      if (tabelaWasUpdated) {
        await this.calculateProcedimentos()
      }
    }

    this.updatePorte()
    this.updateTabela()
  }

  setInitialPorte() {
    const firstPorte = this.portes[0]
    this.calculadora.dataReferenciaPorte = firstPorte.dataReferencia
  }

  setInitialTabela() {
    const firstTabela = this.tabelasCBHPM[0]
    this.calculadora.codigoTabelaReferencia = firstTabela.codigoTabelaReferencia
  }

  setMaiorPorte(bigger) {
    let isSet = false

    this.calculadora.procedimentos.map((procedimento: any) => {
      if (procedimento.codigoTUSS == bigger.codigoTUSS && !isSet) {
        procedimento.isMaiorPorte = true
        isSet = true
      }
      else procedimento.isMaiorPorte = false
    })
  }

  setTabelaPorteId() {
    const codigoTabelaReferencia = this.calculadora.codigoTabelaReferencia
    const dataReferenciaPorte = this.calculadora.dataReferenciaPorte

    if (this.calculadora.codigoTabelaReferencia) {
      this.tabelasCBHPM.map((tabela) => {
        if (codigoTabelaReferencia == tabela.codigoTabelaReferencia) {
          this.tabelaId = tabela.identificador
          this.calculadora.idTabelaReferencia = tabela.identificador
        }
      })
    }

    if (this.calculadora.dataReferenciaPorte) {
      this.portes.map((porte) => {
        if (dataReferenciaPorte == porte.dataReferencia) {
          this.porteId = porte.identificador
          this.calculadora.idPorte = porte.identificador
        }
      })
    }
  }

  toggleModalAddProcedimento() {
    this.modalProcedimentosListIsOpen = !this.modalProcedimentosListIsOpen
  }

  ga(event: string, action: string) {
    this.$ga.event(event, action, this.$user.profile.email)
  }

  updatePorte() {
    const dataReferenciaPorte = this.calculadora.dataReferenciaPorte

    this.portes.map((porte) => {
      if (dataReferenciaPorte == porte.dataReferencia) {
        this.calculadora.idPorte = porte.identificador
      }
    })
  }

  updateTabela() {
    const codigoTabelaReferencia = this.calculadora.codigoTabelaReferencia

    this.tabelasCBHPM.map((tabela) => {
      if (codigoTabelaReferencia == tabela.codigoTabelaReferencia) {
        this.calculadora.idTabelaReferencia = tabela.identificador
      }
    })
  }

  created() {
    this.ativarTabelaCBHPMStatus(false)
  }
}
